import { ResizeEditorState } from "../../types";

export const toggleHorizontal = (state: ResizeEditorState) => {
    state.flip.horizontal = !state.flip.horizontal;
    state.operations.push({
        name: "flip",
        value: { value: "horizontal", rotation: state.rotate.rotation },
    });
};
